import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import classNames from 'classnames';

import {
  ENTITY_LOADING_STATUS_START,
  ENTITY_LOADING_STATUS_LOADING,
} from '@uncinc/react-drupal-core';

import './style.scss';

const Page = ({
  children,
  className,
  loading,
  referenceLoading,
  title,
  path,
  prevPath,
  ...props
}) => {
  const pathChanged = (path !== prevPath && typeof prevPath !== 'undefined');
  const hasLoadingItems = referenceLoading.get('itemsStarted') > 0;
  const isLoading = pathChanged && hasLoadingItems && referenceLoading.get('itemsStarted') > referenceLoading.get('itemsFinished');

  const entityLoadingStatus = useSelector((state) => state.getIn(['entity', 'loadingStatus']));
  const entityLoading = (entityLoadingStatus === ENTITY_LOADING_STATUS_START || entityLoadingStatus === ENTITY_LOADING_STATUS_LOADING);

  useEffect(() => {
    if (!entityLoading && window.location.hash) {
      // Linking to hash from external does not seem to work with React(router?)
      // This is a simple workaround.
      //
      // Setting the window href makes the browser do the scrolling.
      // This way we don't need to do querySelectors and scrollTo functions
      setTimeout(() => {
        window.location.href = window.location.hash;
      }, 800);
      return;
    }

    if (!hasLoadingItems || !pathChanged) {
      return;
    }

    // We want to hide the scrollTo behind the page transition.
    // The original logic was not specific enough.
    // We don't want to trigger the scrollTo before the transition animation
    // has started.
    if (
      // To entity navigation, done loading
      (title && !isLoading) ||
      // Navigate to homepage, done loading
      (!title && !isLoading) ||
      // Navigate to e.g. 404
      (!title && isLoading)
    ) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant',
      });
    }
  }, [hasLoadingItems, pathChanged, title, isLoading, entityLoading]);

  const classes = classNames(className, 'Page');
  const contentWrapperClasses = classNames('page--inner-wrapper', {
    'has-loading-items': hasLoadingItems,
    loading: isLoading,
  });

  return (
    <div className={classes}>
      <div className={contentWrapperClasses}>
        {children}
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    referenceLoading: state.getIn(['ui', 'referenceLoading']),
  };
}

export default connect(mapStateToProps)(Page);
